import React from "react";

const QuestionText = ({ question, defaultValue, onAnswer }) => {
	return (
		<div className="flex flex-col items-center bg-white p-4 px-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
			{question.category && (
				<div className="text-sm text-gray-800 font-bold mb-2">
					{question.category}:
				</div>
			)}
			<h3 className="text-sm mb-4">{question.text}</h3>
			<textarea
				value={defaultValue}
				onChange={(e) => onAnswer(e.target.value)}
				className="w-full p-2 border rounded"
				placeholder="Type your answer here..."
			/>
		</div>
	);
};

export default QuestionText;
